"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDropZone = exports.StyledLeftCard = exports.StyledDndCard = exports.StyledRightBlock = exports.StyledLeftBlock = exports.StyledMain = void 0;
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledMain = (0, styled_components_1.default)(material_1.Box) `
  && {
    height: ${(props) => (`${props.$height}px`)};
    position: relative;

    .HP-main-block {
      height: 100%;
      display: flex;
      justify-content: space-between;
    }

    .HP-button-reset {
      position: absolute;
      height: 40px;
      bottom: 0;
    }

  }
`;
exports.StyledLeftBlock = (0, styled_components_1.default)(material_1.Box) `
  && {
    border-right: 1px solid ${ui_components_1.baseColors.background300};
    box-sizing: border-box;
    width: 50%;
    position: relative;
    margin-bottom: 40px;

    .HP-left-block-search {
      position: absolute;
      width: calc(100% - 20px);
      height: 40px;
      top: 0;
    }

    .HP-left-block-cards {
      height: calc(100% - 40px);
      margin-top: 40px;
      overflow: auto;
    }

  }
`;
exports.StyledRightBlock = (0, styled_components_1.default)(material_1.Box) `
  && {
    width: 50%;
    position: relative;
    margin-bottom: 40px;

    .HP-right-block-title {
      position: absolute;
      width: 100%;
      height: 20px;
      top: 0;
      padding-left: 20px;
      font-weight: 700;
      font-size: 14px;
      color: ${ui_components_1.baseColors.disabled};
    }

    .HP-right-block-content {
      height: calc(100% - 20px);
      margin-top: 20px;
      overflow: auto;
    }

  }
`;
exports.StyledDndCard = (0, styled_components_1.default)(material_1.Box) `
  && {
    color: ${(props) => (`${props.$default ? ui_components_1.baseColors.disabled : ui_components_1.baseColors.black}`)};
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 10px 5px 25px;
    height: 18px;
    margin-left: 17px;
    margin-right: 17px;
    position: relative;

    .HP-dnd-icon-drag {
      cursor: pointer;
      position: absolute;
      left: 0;
    }

    .HP-dnd-title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .HP-dnd-description {
      font-weight: 700;
      font-size: 12px;
      font-style: italic;
      color: ${ui_components_1.baseColors.disabled};
    }

    .HP-dnd-icon-remove {
      cursor: pointer;
      position: absolute;
      right: -15px;
    }

  }
`;
exports.StyledLeftCard = (0, styled_components_1.default)(material_1.Box) `
  && {
    display: flex;
    height: 20px;
    padding: 5px 25px 5px 10px;
    justify-content: space-between;
    align-items: center;

    .HP-left-card-title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .HP-left-card-icon {
      cursor: pointer;
    }
    
  }
`;
exports.StyledDropZone = (0, styled_components_1.default)(material_1.Box) `
  && {
    width: 100%;
    height: 30px;
    background: ${ui_components_1.baseColors.primaryBlueAccent200}
  }
`;
